import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit';
import { EPlatform } from '@cian/webview/shared';

import { EPageTypes } from '../../constants/page';
import { ERateValues } from '../../types/redux/rateOurEstimation';
import { getSiteType } from '../../utils/getSiteType';

export interface ITrackSaveScoreRateProps {
  label?: ERateValues;
  deviceType: TDeviceType;
  fairprice?: number;
  comment?: string;
  platform: EPlatform | null;
  houseId?: number;
  pageType: EPageTypes;
}

export function trackSaveScoreRate({
  label,
  deviceType,
  fairprice,
  comment,
  platform,
  houseId,
  pageType,
}: ITrackSaveScoreRateProps) {
  const labelCa = houseId ? `${label}/${houseId}` : label;

  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'user_estimate_send',
    label: labelCa,
    page: {
      siteType: getSiteType(deviceType),
      pageType,
      extra: {
        fairprice,
        comment,
        type: platform || undefined,
      },
    },
  });
}
